import { SoftwarePackageV2 } from '@models/softwarePackge';
import StopWatch from '@images/SotwarePackages/stop-watch.svg';
import LockShield from '@images/SotwarePackages/lock-shield.svg';
import ExpandArrows from '@images/SotwarePackages/expand-arrows.svg';
import Seatbelt from '@images/SotwarePackages/seatbelt.svg';
import TrafficLight from '@images/SotwarePackages/traffic-light.svg';
import GearMagnifyingGlass from '@images/SotwarePackages/gear-magnifying-glass.svg';
import Lightbulb from '@images/SotwarePackages/lightbulb.svg';
import Leaf from '@images/SotwarePackages/leaf.svg';
import Warranty from '@images/SotwarePackages/warranty.svg';
import Wifi from '@images/SotwarePackages/wifi.svg';
import Device from '@images/SotwarePackages/device.svg';
import Scale from '@images/SotwarePackages/scale.svg';
import Usage from '@images/SotwarePackages/usage.svg';
import Support from '@images/SotwarePackages/support.svg';
import DemoFormBackground from '@images/SiteWideDemoForm/IT-IT.jpg';

export const itSoftwarePackages: SoftwarePackageV2 = {
    version: 2,
    seo: {
        title: 'Piani tariffari | Geotab',
        description: 'Confronta le caratteristiche e scegli il piano più adatto alle tue esigenze di Fleet Management.',
    },
    getPrices: 'Scopri i prezzi',
    demoFormBackgroundImage: DemoFormBackground,
    header: {
        title: 'Il nostro pacchetto più completo ideato per soddisfare le tue esigenze',
        description:
            'Geotab potenzia la tua flotta offrendo risultati tangibili che supportano i tuoi obiettivi operativi e generano valore a lungo termine. Tramite la nostra tecnologia e le analisi sui dati, i clienti possono prendere decisioni informate per migliorare le prestazioni, la sicurezza, la sostenibilità e la gestione dei costi..',
        featured: [
            'Dati di qualità e completezza senza precedenti',
            'Piattaforma flessibile, personalizzabile e scalabile',
            'Piattaforma affidabile che assicura la protezione dei dati',
            'Algoritmo brevettato che rivoluziona l\'acquisizione dei dati',
            'AI e modelli di analisi predittiva',
            'Supporto personalizzato 24/7',
        ],
        cta: {
            bannerText: 'Libera tutto il valore della telematica con il GO Plan',
            title: 'GO Plan',
            subtitle: 'Globale',
            description:
                'Progettato per offrire dati ottimizzati, insight più completi e una maggiore compatibilità con una più ampia gamma di prodotti, il GO Plan è un piano unico che offre il massimo valore ai clienti.',
        },
    },
    goPlanBenefits: {
        title: 'Funzionalità',
        subtitle: 'Accedi a tutte le funzionalità del tuo dispositivo GO con il GO Plan',
        description:
            'Elimina la complessità della gestione degli abbonamenti e ottieni un accesso completo per potenziare le decisioni relative alla gestione della flotta e all\'efficienza operativa.',
        features: [
            {
                title: 'Sottoscrizione telematica tutto in uno',
                description:
                    'Nessun livello per provare tutto quello che offre la piattaforma. Un piano semplice con meno amministrazione e più insight.',
                icon: Device,
            },
            {
                title: 'Scalabilità senza restrizioni',
                description:
                    'Adatta senza sforzo l\'utilizzo di funzionalità avanzate e di intelligenza dei dati alla crescita della tua attività.',
                icon: Scale,
            },
            {
                title: 'Tachigrafo',
                description: 'Stato e dati del tachigrafo in tempo reale (TAC). Gestione delle infrazioni (AFA)',
                icon: Wifi,
            },
            {
                title: 'Impara man mano che il tuo utilizzo cresce',
                description:
                    'Padroneggia l\'intera piattaforma con facilità. Accedi a guide e tutorial integrati nell\'app per massimizzare il ROI del tuo investimento telematico.',
                icon: Usage,
            },
            {
                title: 'Accesso per esperti',
                description:
                    'La tua attività è sempre attiva, così come il nostro supporto. Ottieni l\'accesso agli esperti 24 ore su 24, 7 giorni su 7, 365 giorni all\'anno.',
                icon: Support,
            },
            {
                title: 'Garanzia a vita limitata sul dispositivo',
                description:
                    'Ti protegge dai costi di guasto del dispositivo, offrendoti tranquillità con una garanzia senza preoccupazioni.',
                icon: Warranty,
            },
        ],
    },
    categories: [
        {
            title: 'Produttività',
            icon: StopWatch,
            features: [
                'Tracciamento GPS istantaneo con algoritmi brevettati basati su curve per una registrazione ottimale',
                'Regole altamente flessibili e eccezione motore - personalizzabili e modificabili',
                'Segnalazione aggregazione conducenti',
                'Localizzazione del veicolo più vicino per indirizzo',
                'ID conducente tramite NFC',
                'Messaggio e invio percorsi ai conducenti con PND Garmin compatibili',
            ],
        },
        {
            title: 'Sicurezza',
            icon: Seatbelt,
            features: [
                'Coaching di base per i conducenti: Avvisi e notifiche acustici per la velocità, le soste a motore acceso e l’identificazione del conducente',
                'Coaching di base per i conducenti e regole ed eccezioni lato server personalizzabili',
                'Coaching avanzato per i conducenti: Avvisi e notifiche acustici per frenate brusche, sterzata brusca, eccesso di accelerazione, utilizzo delle cinture di sicurezza, guida in retromarcia, giri motore eccessivi',
                'Nuovo rilevamento delle collisioni minori e gravi',
                'Centro per la sicurezza: Analisi della sicurezza predittiva e benchmark',
            ],
        },
        {
            title: 'Ottimizzazione della flotta',
            icon: GearMagnifyingGlass,
            features: [
                'Promemoria per la manutenzione programmata dei veicoli in base all\'ora o alla distanza',
                'Promemoria per la manutenzione dei veicoli in base al chilometraggio o alle ore motore',
                'Facile installazione del dispositivo con l’Accelerometro autocalibrante',
                'Dati sullo stato motore per tutti i principali protocolli motore (utilizzo del carburante, tensione, liquido di raffreddamento, temp.)',
                'Registrazione e interpretazione dei dati relativi al guasto (J1939, 1708, OBD, CAN)',
                'Add-in Geotab Roadside per traino, fabbro serraturista, avviamento di emergenza, fornitura di carburante, cambio gomme in caso di foratura gratuiti e altro ancora',
                'Piattaforma per la gestione del carburante — Monitorare il pieno di carburante, la fine del carburante, il furto di carburante e l’integrazione della carta carburante',
            ],
        },
        {
            title: 'Espandibilità',
            icon: ExpandArrows,
            features: [
                'Piattaforma di reportistica software (SaaS) basata sul web in grado di supportare un numero illimitato di veicoli e utenti',
                'Supporto di più tipi di mappa',
                'Funzionalità di reportistica complete - modificabili, personalizzabili, tendenze',
                'Dashboard personalizzabili',
                'Controllo accesso utenti flessibile',
                'Accesso a MyGeotab tramite Android e IOS',
                'SDK e API aperti, gratuiti e facili da usare',
                'Accesso alle soluzioni e agli Add-On di partner tramite il Marketplace di Geotab',
                'Garanzia a vita limitata del dispositivo',
                'Integrazione Add-On IOX di base (IOX-GOTALK, IOX-AUX, IOX-BUZZ, IOX-NFCREADERA) con periferiche e dispositivi all\'interno del veicolo',
                'Integrazione Add-On IOX avanzata (IOX-BT, IOX-USB, IOX-CAN, IOX-WRKS e Add-On adibiti al controllo dello spargimento di sostanze IOX-RS232M/F/D) con periferiche e dispositivi all’interno del veicolo',
                'Active Tracking: Soluzione di monitoraggio di qualità premium che fornisce informazioni sulla posizione con frequenza e precisione più elevate',
            ],
        },
        {
            title: 'Conformità',
            icon: TrafficLight,
            features: [
                'Identificazione della manomissione del dispositivo',
                'Applicazione conducente (Geotab Drive) scalabile per necessità future',
                'Conformità HOS tramite Geotab Drive (Android/iOS) e Garmin',
                'Conformità DVIR tramite Geotab Drive (Android/IOS)',
                'Registrazione miglia IFTA',
                'Modalità Personale',
            ],
        },
        {
            title: 'Sostenibilità',
            icon: Leaf,
            features: [
                'Analisi di Sostenibilità dei Veicoli Elettrici (EVSA)',
                'Valutazione dell\'Infrastruttura dei Veicoli Elettrici (EVIA)',
                'Energia di guida dell\'EV utilizzata',
                'Percentuale di ricarica della batteria dell\'EV (SOC)',
                'Energia di ricarica dell\'EV',
                'Stato di ricarica dell\'EV',
                'Ubicazione delle stazioni di ricarica EV',
            ],
        },
        {
            title: 'Innovazione',
            icon: Lightbulb,
            features: ['AI generativa', 'Pianificazione ed ottimizzazione dei percorsi', 'Geotab Data Connector'],
        },
        {
            title: 'Privacy e Sicurezza',
            icon: LockShield,
            features: [
                'Un quadro di riferimento responsabile per risultati incentrati sulla privacy',
                'Convalida FIPS 140-2',
                'Autorizzazione Fed Ramp',
                'ISO-IEC 27001:2013',
                'UNECE 155/156',
                'Scelto da molte delle maggiori organizzazioni di sicurezza del mondo',
            ],
        },
    ],
};
